export const InvoiceStatusValue = {
  All: 'All',
  NotReady: 'NotReady'
}
